import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-recycling',
  templateUrl: './recycling.page.html',
  styleUrls: ['./recycling.page.scss'],
})
export class RecyclingPage implements OnInit {

  
  public assets = environment.assets;

  constructor() { }

  ngOnInit() {
  }

}
